module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/create.js
// module id = 271
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13